'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'thumbtack';
var width = 384;
var height = 512;
var aliases = [128204,128392,"thumb-tack"];
var unicode = 'f08d';
var svgPathData = 'M48.3 32L87.6 32 76 188.6C41.2 214.6 15.6 253 6.1 298.1l-1.2 5.7C-.4 328.6 18.6 352 44 352l296.6 0c25.4 0 44.4-23.4 39.1-48.2l-1.2-5.7c-9.5-45.1-35.1-83.5-70-109.5L297 32 336.3 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L48.3 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm59.1 166.2L119.7 32 264.9 32 277.2 198.2c.3 4.6 2.7 8.9 6.4 11.6l5.8 4.4c28.8 21.5 50 53.2 57.8 90.5l1.2 5.7c1 5-2.7 9.6-7.8 9.6L44 320c-5.1 0-8.9-4.7-7.8-9.6l1.2-5.7c7.9-37.3 29-69 57.8-90.5l5.8-4.4c3.7-2.8 6-7 6.4-11.6zM176.3 400l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128-32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbtack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;